import React from 'react'
import Swal from 'sweetalert2'
import { VscError } from "react-icons/vsc";
import withReactContent from 'sweetalert2-react-content'
import { FaRegCircleCheck } from 'react-icons/fa6';
export default function errorModel(error,message) {
  const MySwal = withReactContent(Swal)
  return  MySwal.fire({
   
    html:   <>
    {error==="error" ?
      <div className="flex gap-2 items-center">
    
      <VscError className="text-red-600 text-4xl "/>
                  <h2 className="text-[#A3A3A3] text-xl">Error</h2>
                   </div>
   
                :
                <div className="flex gap-2 items-center">
    
                <FaRegCircleCheck className="text-green-600 text-4xl "/>
                           <h2 className="text-[#A3A3A3] text-xl">Success</h2>
                            </div>
                 }
                <div className="py-7">
                   
                   <p className="p text-left">{message}</p>
                   </div>
  </>,
    showCloseButton: false,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonColor:" #606C5D",
    confirmButtonText: <div className="w-[240px]">OK</div>
  
   
    })
}
